/**
 * HOW AN ELEMENT THE USER ADDS BY HAND STARTS (Beka, 2026-09-27: "users can manually put Text, Circle, Square,
 * Image on the artifact"). The live bridge draws it and the source writes it from these same values, so the
 * frame and the stored document cannot drift. Its own module, like `boxCss`, so neither side imports the
 * other.
 *
 * Everything is the artifact's own: its body face, its text colour, its accent. A token follows a re-theme,
 * so a shape added today is still the deck's accent after the palette changes.
 */

/** A placeholder's words, for a text box added with words already in it. The dock's opens empty, a caret only. */
export const ADDED_TEXT = 'Text'

/** The longest text a new box may be created with: a placeholder, not content. */
export const ADDED_TEXT_MAX = 200

/**
 * The longest text pasted in from outside as a new text box (2026-09-27): about a slide's worth of words at the
 * box's 44px. Longer is cut at a word, and the user is told.
 */
export const PASTED_TEXT_MAX = 2000

/**
 * A new text box's type, as plain inline declarations: the same way the text bar writes type, and not hand
 * props (a hand edit never sets type). 44px is the top of the contract's body scale.
 */
export const ADDED_TEXT_STYLE: ReadonlyArray<readonly [string, string]> = [
  ['font-family', 'var(--a-font-body)'],
  ['font-size', '44px'],
  ['line-height', '1.25'],
  ['color', 'var(--a-text)'],
]

/** One line of that type, in artifact px (44 × 1.25): a click on the slide centres the caret's line on it. */
export const ADDED_TEXT_LINE = 55

/**
 * A new circle's or square's fill: a neutral gray, Figma's #D9D9D9 (Beka, 2026-09-27: "Circle and Rectangle should
 * have default gray color"; it was the deck's accent). The same on every kit: a placeholder until it is coloured.
 * Written as `rgb()`, the way the Properties pane writes the colours it picks.
 */
export const ADDED_SHAPE_FILL = 'rgb(217, 217, 217)'

/** A circle's corners: a percentage, so it stays an ellipse at any size a resize gives it. */
export const ADDED_ROUND = '50%'
